import React from 'react';
import { useTranslation } from 'react-i18next';
import { Responsive } from '../../../../responsive/responsive';
import { Grid } from '../../../../grid/grid';
import { Slideshow } from '../../../../swiper/swiper';
import { Section } from '../../../../section/section';
import { SkeletonPieChart } from '../../../chart/pie/skeleton-pie-chart/skeleton-pie-chart';
import { DashboardChartsItem } from '../../../../../../blocks/app/dashboard/trades/charts/item/dashboard-trades-charts-item';

export const SkeletonDashboardCharts: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="pt-small pb-xlarge max-vl:overflow-hidden">
            <Section>
                <Responsive breakpoint={'vl'} type={'max'}>
                    <>
                        <Responsive breakpoint={'md'} type={'min'}>
                            <Slideshow>
                                <Grid cols={2}>
                                    <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                        <DashboardChartsItem
                                            title={t('pages.index.graphTitle.assetType')}
                                            chart={<SkeletonPieChart legendItems={2} />}
                                        />
                                    </div>
                                    <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                        <DashboardChartsItem
                                            title={t('pages.index.graphTitle.portfolio')}
                                            chart={<SkeletonPieChart legendItems={2} />}
                                        />
                                    </div>
                                </Grid>
                                <Grid cols={2}>
                                    <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                        <DashboardChartsItem
                                            title={t('pages.index.graphTitle.currency')}
                                            chart={<SkeletonPieChart legendItems={3} />}
                                        />
                                    </div>
                                    <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                        <DashboardChartsItem
                                            title={t('pages.index.graphTitle.country')}
                                            chart={<SkeletonPieChart legendItems={2} />}
                                        />
                                    </div>
                                </Grid>
                                <Grid cols={2}>
                                    <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                        <DashboardChartsItem
                                            title={t('pages.index.graphTitle.sector')}
                                            chart={<SkeletonPieChart legendItems={2} />}
                                        />
                                    </div>
                                    <></>
                                </Grid>
                            </Slideshow>
                        </Responsive>
                        <Responsive breakpoint={'md'} type={'max'}>
                            <Slideshow>
                                <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                    <DashboardChartsItem
                                        title={t('pages.index.graphTitle.assetType')}
                                        chart={<SkeletonPieChart legendItems={2} />}
                                    />
                                </div>
                                <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                    <DashboardChartsItem
                                        title={t('pages.index.graphTitle.portfolio')}
                                        chart={<SkeletonPieChart legendItems={2} />}
                                    />
                                </div>
                                <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                    <DashboardChartsItem
                                        title={t('pages.index.graphTitle.currency')}
                                        chart={<SkeletonPieChart legendItems={3} />}
                                    />
                                </div>
                                <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                    <DashboardChartsItem
                                        title={t('pages.index.graphTitle.country')}
                                        chart={<SkeletonPieChart legendItems={1} />}
                                    />
                                </div>
                                <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                    <DashboardChartsItem
                                        title={t('pages.index.graphTitle.sector')}
                                        chart={<SkeletonPieChart legendItems={1} />}
                                    />
                                </div>
                            </Slideshow>
                        </Responsive>
                    </>
                </Responsive>
                <Responsive breakpoint={'vl'} type={'min'}>
                    <Grid cols={{ xs: 1, md: 2, vl: 3 }}>
                        <Grid cols={{ xs: 1 }}>
                            <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                <DashboardChartsItem
                                    title={t('pages.index.graphTitle.assetType')}
                                    chart={<SkeletonPieChart legendItems={1} />}
                                />
                            </div>
                            <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                <DashboardChartsItem
                                    title={t('pages.index.graphTitle.portfolio')}
                                    chart={<SkeletonPieChart legendItems={3} />}
                                />
                            </div>
                        </Grid>
                        <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                            <DashboardChartsItem
                                title={t('pages.index.graphTitle.currency')}
                                chart={<SkeletonPieChart legendItems={2} orientation={'vertical'} />}
                            />
                        </div>
                        <Grid cols={{ xs: 1 }}>
                            <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                <DashboardChartsItem
                                    title={t('pages.index.graphTitle.country')}
                                    chart={<SkeletonPieChart legendItems={1} />}
                                />
                            </div>
                            <div className="flex h-full flex-col rounded-large border border-border p-medium [&>*]:h-full vl:max-xl:p-vsmall">
                                <DashboardChartsItem
                                    title={t('pages.index.graphTitle.sector')}
                                    chart={<SkeletonPieChart legendItems={1} />}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Responsive>
            </Section>
        </div>
    );
};
